import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import { Headline } from '@dfds-ui/react-components';
import { useLoginModal } from '../user-management/LoginModal';

var FlowScreenHeader = function FlowScreenHeader(_ref) {
  var content = _ref.content;

  var _useLoginModal = useLoginModal(),
      insideModal = _useLoginModal.insideModal,
      setHeading = _useLoginModal.setHeading;

  React.useEffect(function () {
    return setHeading(content);
  }, [content, setHeading]);
  return insideModal ? null : ___EmotionJSX(Headline, {
    as: "h2"
  }, " ", content, " ");
};

export default FlowScreenHeader;